import "./mobile.scss";

import { useEffect, useLayoutEffect, useState } from "react";
import { TrendingUp } from "react-feather";
import { useNavigate } from "react-router-dom";

import { SkyButton, YellowButton } from "../../../../shared/Buttons/Buttons";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
// import { THINKFIC_BASE_URL } from "../../../../apiConfigs/urlConfig";
import {
  enrollToThinkificCourse3,
  loginToThinkificAndRedirect,
} from "../../../../store/features/Thinkific/ThikificApi";
import { roles } from "../../../../helpers/utils/Constants/roles";
import {
  checkNormalUser,
  hasAnyFreeRole,
  isFreeSelfPacedUser,
  isSelfPacedRole,
} from "../../../../helpers/utils/roleUtils";

/* eslint-disable prefer-template */
const MobileViewSprint = () => {
  const [loadingCourseid, setLoadingCourseid] = useState(0);
  const [loadingSprintid, setLoadingSprintid] = useState(0);
  const [slug, setSlug] = useState("");
  const navigate = useNavigate();

  const dashState: any = useAppSelector((store: RootStore) => {
    return store.NewDashboard;
  });

  const thinkificState: any = useAppSelector((store: RootStore) => {
    return store.ThinkificSlice;
  });
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });
  const themeState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });
  const isNormalUser = checkNormalUser(authState);

  const dispatch = useAppDispatch();

  const startLearning = (
    slug: string,
    courseId: number,
    id: number,
    sprintId: number
  ) => {
    setLoadingCourseid(id);
    setLoadingSprintid(sprintId);
    setSlug(slug);
    dispatch(enrollToThinkificCourse3({ courseId: courseId })).then((res) => {
      dispatch(
        loginToThinkificAndRedirect({
          slug: slug,
        })
      ).then((res: any) => {
        if (res.payload) {
          console.log(res.payload.url);
          window.open(res.payload.url, "_blank");
        }
      });
    });
  };
  useLayoutEffect(() => {
    const path: any = document.getElementById("line");
    path.style.setProperty("--offsetDistance", "40px");
  }, []);

  useEffect(() => {
    if (thinkificState.req_success3) {
      window.location.href = `${themeState.configs.site_url}/login/${authState.tac_user.email}/${slug}`;
    }
  }, [thinkificState.req_success3]);
  window.addEventListener("scroll", (e) => {
    const path: any = document.getElementById("line");
    const pathLength = path?.clientHeight;
    const scroll = window.scrollY;
    if (scroll < pathLength) {
      if (scroll === 0) {
        path.style.setProperty("--offsetDistance", "40px");
      } else {
        path.style.setProperty("--offsetDistance", `${scroll + 40}px`);
      }
    } else {
      path?.style.setProperty("--offsetDistance", `${pathLength - 10}px`);
    }
  });
  const isSelfPacedUser = isSelfPacedRole(authState?.tac_user?.role, authState);
  const freeSelfPacedUser = isFreeSelfPacedUser(authState);
  const isAIBusinessAnalyst = authState?.tac_user?.all_roles?.includes(
    roles.AI_BUSINESS_ANALYST_STUDENT
  );
  return (
    <div className="mobile__view__padding">
      {" "}
      <div className="mobile__sprint__wrapper">
        <div className="animation__line__wrapper_div">
          <div className="animation__line__wrapper" id="line" />
          <div className="all_content__section">
            {/* !isSelfPacedUser && !dashState.loading.onboarding &&
            !freeSelfPacedUser && !isAIBusinessAnalyst &&
            dashState.req_success.onboarding */}
            {isNormalUser && (
              <div className="onboarding__content__section">
                <h1 className="sprint__title title">
                  {" "}
                  {dashState.onboarding?.onboarding?.name}
                </h1>
                <p className="onboarding__description">
                  {dashState.onboarding?.onboarding?.description}
                </p>
                <div className="onboarding__button__section ">
                  {!isSelfPacedUser && (
                    <YellowButton
                      text="Onboarding"
                      onClick={() =>
                        startLearning("onboarding", 2066635, 11111111, 1)
                      }
                      animationLoading={
                        thinkificState.loading && loadingCourseid === 11111111
                      }
                    />
                  )}
                  {authState?.tac_user?.role ===
                    roles.SELF_PACED_PRODUCT_MANAGER_STUDENT && (
                    <YellowButton
                      text="Onboarding"
                      onClick={() =>
                        startLearning(
                          "product-manager-self-paced-onboarding",
                          2818425,
                          11111111,
                          1
                        )
                      }
                      animationLoading={
                        thinkificState.loading && loadingCourseid === 11111111
                      }
                    />
                  )}
                  {authState?.tac_user?.role ===
                    roles.SELF_PACED_SCRUM_MASTER_STUDENT && (
                    <YellowButton
                      text="Onboarding"
                      onClick={() =>
                        startLearning(
                          "scrum-master-self-paced-onboarding",
                          1980675,
                          11111111,
                          1
                        )
                      }
                      animationLoading={
                        thinkificState.loading && loadingCourseid === 11111111
                      }
                    />
                  )}
                  {authState?.tac_user?.role ===
                    roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT && (
                    <YellowButton
                      text="Onboarding"
                      onClick={() =>
                        startLearning(
                          // "agile-project-manager-self-paced-onboarding",
                          "onboarding",
                          2066635,
                          11111111,
                          1
                        )
                      }
                      animationLoading={
                        thinkificState.loading && loadingCourseid === 11111111
                      }
                    />
                  )}
                </div>
                <h6 className="lessons"> lessons in this course:</h6>
                {dashState.onboarding?.bullet_points?.map(
                  (point: any, i: number) => {
                    return (
                      <div className="lesson__section" key={point.description}>
                        <TrendingUp className="trending__up" />
                        <span className="lesson">{point.description}</span>
                      </div>
                    );
                  }
                )}
              </div>
            )}
            <div className="mt-3" />
            {!dashState.loading.filter_course &&
              dashState.req_success.filter_course &&
              dashState.all_sprints.map((sprint: any, i: number) => {
                return (
                  <div className="all_sprint__list " key={sprint.id}>
                    <h1
                      className={`single__sprint__title ${
                        (i + 1) % 2 !== 0 ? "green" : ""
                      } `}
                    >
                      {" "}
                      {sprint.name}
                    </h1>
                    <p className="onboarding__description">
                      {sprint.description}
                    </p>
                    <div className="all_sprints__section">
                      {sprint.courses.map((course: any) => {
                        return (
                          <div>
                            <YellowButton
                              text={course.name}
                              key={course.id}
                              onClick={() =>
                                startLearning(
                                  course.slug,
                                  course.course_id,
                                  course.id,
                                  sprint.id
                                )
                              }
                              animationLoading={
                                loadingSprintid === sprint.id &&
                                loadingCourseid === course.id
                              }
                            />

                            <p className="lessons text__transform">
                              {course.description}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            {!isSelfPacedUser && !freeSelfPacedUser && (
              <div className="mobile__beyond__section">
                <h1 className="sprint__title"> Beyond</h1>
                <p>
                  Here's what we have to offer you in addition to our courses.
                  Go BEYOND, broaden your horizons, and increase your knowledge
                  by reading more.
                </p>
                <div className="beyond-button-section">
                  <SkyButton
                    text="Advanced Tech Terms"
                    onClick={() =>
                      startLearning("advanced-tech-terms", 1982299, 2222222, 1)
                    }
                    animationLoading={loadingCourseid === 2222222}
                  />
                  <SkyButton
                    text="New Job Onboarding"
                    onClick={() =>
                      startLearning("new-agile", 1994177, 1212121212, 1)
                    }
                    animationLoading={loadingCourseid === 1212121212}
                  />{" "}
                  <SkyButton
                    text="All Courses"
                    onClick={() => navigate("/user-allcourses")}
                    animationLoading={false}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileViewSprint;
